import { PaymentMethodProviderType } from '@40seas/entities/payment-methods';
import { z } from 'zod';
import { EnumSchema, FromSchema } from '@40seas/entities/common';
import { RefundStatus } from '../refund.status.enum';
import { Currency } from '@40seas/models';

export const RefundReconciliationSchema = z
    .object({
        id: z.string().regex(/^[0-9a-f]{24}$/i),
        buyerLegalName: z.string(),
        supplierLegalName: z.string(),
        amount: z.number(),
        status: EnumSchema(RefundStatus),
        completionDate: z.date(),
        provider: EnumSchema(PaymentMethodProviderType),
        revenue: z.number().optional(),
        invoice: z
            .string()
            .regex(/^[0-9a-f]{24}$/i)
            .optional(),
        checkout: z
            .string()
            .regex(/^[0-9a-f]{24}$/i)
            .optional(),
        currency: EnumSchema(Currency).nullish(),
    })
    .strict();

export class RefundReconciliation extends FromSchema(RefundReconciliationSchema) {
    id: string;
    buyerLegalName: string;
    supplierLegalName: string;
    amount: number;
    currency: Currency;
    status: RefundStatus;
    completionDate: Date;
    provider: PaymentMethodProviderType;
    revenue: number;
    invoice: string;
    checkout: string;
}
